class DocumentApiClient {
  urls = null;
  ccToken = null;
  userToken = null;

  constructor(urls) {
    this.urls = {
      backOffice: urls.backOffice,
      assetStorage: urls.assetStorage,
    };
  }

  setCcToken(ccToken) {
    this.ccToken = ccToken;
  }

  setUserToken(userToken) {
    this.userToken = userToken;
  }

  async getDocuments(boProductId, boVariantId, boProductVersionId, boTenantId, documentCustomFields) {
    const url = new URL(this.urls.backOffice);
    url.pathname = `/api/storefront/v1/products/${boProductId}/variant-documents`;
    url.searchParams.append('productVariantId', boVariantId);
    url.searchParams.append('productVersionId', boProductVersionId);
    url.searchParams.append('tenantId', boTenantId);
    if (!!documentCustomFields) {
      url.searchParams.append('documentCustomFields', documentCustomFields)
    }

    return await fetch(url.href, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${this.userToken}`,
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json());
  }

  async getDocumentsLite(boProductId, boTenantId, documentCustomFields) {
    const url = new URL(this.urls.backOffice);
    url.pathname = `/api/storefront/v1/products/${boProductId}/variant-documents`;
    url.searchParams.append('tenantId', boTenantId);
    if (!!documentCustomFields) {
      url.searchParams.append('documentCustomFields', documentCustomFields)
    }

    return await fetch(url.href, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${this.userToken}`,
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json());
  }

  async getDocumentFile(documentId, boTenantId) {
    const url = new URL(this.urls.assetStorage);
    url.pathname = `/api/storage/v1/documents/${documentId}/file`;
    url.searchParams.append('attachment', true);
    url.searchParams.append('tenantId', boTenantId);
    
    return await fetch(url.href, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${this.userToken}`,
        'Content-Type': 'application/octet-stream',
      },
    }).then((response) => response.text());
  }
}